    import moment from 'moment';
    let months = {
          "01":"มกราคม",
          "02":"กุมภาพันธ์",
          "03":"มีนาคม",
          "04":"เมษายน",
          "05":"พฤษภาคม",
          "06":"มิถุนายน",
          "07":"กรกฎาคม",
          "08":"สิงหาคม",
          "09":"กันยายน",
          "10":"ตุลาคม",
          "11":"พฤศจิกายน",
          "12":"ธันวาคม"
    }
    let keyMonths = ['01','02','03','04','05','06','07','08','09','10','11','12']
 export function objSearch(obj){
        let str = '';
        let strArr = [];
        for(let i in obj){
            strArr.push(`${i}=${obj[i]}`)
        }
        str = strArr.join('&')
        return str == ''?'':'?'+str
    }
 export function tsDateToThaiDate(date = null){
        if(!date){
            return '';
        }

    let date_ = moment(date,'DD/MM/YYYY')
    if(keyMonths.indexOf(date_.format('MM'))  > -1){
        return `วันที่ ${parseInt(date_.format('DD'))} ${months[date_.format('MM')]} ${date_.format('YYYY')}`
    }

    return ''
}


 export function Default_Report_Year()
	{
		let $month = moment().month();
		let $year = moment().year();
		if ($month >= 1 && $month<=12)
		{
			return ($year+542);
		}
	}



// WEBPACK FOOTER //
// ./src/utils/func.js